import { InjectionToken } from '@angular/core';

export const SCREEN_CODE = new InjectionToken<string>('SCREEN_CODE');
export const CONTAINER_CODE = new InjectionToken<string>('CONTAINER_CODE');
export const DYNAMIC_DIRECTIVE_DATA = new InjectionToken(
  'DYNAMIC_DIRECTIVE_DATA'
);
